export const clientObservationInitialValues = () => {
  return {
    selectMeeting: null,
    feedback: "",
  }
}
